import { toLatinDigits } from './digits.js';

/**
 * Normalizes an Iranian national code (کد ملی) to its 10 Latin digits, or null when it is not
 * one. Persian/Arabic digits, spaces and dashes are accepted. The last digit is a check digit:
 * sum(digit[i] × (10 − i)) mod 11 is `r`; the check digit is `r` when r < 2, else 11 − r.
 * Ten equal digits pass that formula but are never issued, so they are rejected.
 */
export function normalizeIranNationalCode(raw: string): string | null {
  const code = toLatinDigits(raw).replace(/[\s-]/g, '');
  if (!/^[0-9]{10}$/.test(code) || /^(\d)\1{9}$/.test(code)) return null;
  let sum = 0;
  for (let i = 0; i < 9; i += 1) sum += Number(code[i]) * (10 - i);
  const r = sum % 11;
  const check = r < 2 ? r : 11 - r;
  return check === Number(code[9]) ? code : null;
}
